import { DeskBookingsDTO, BookingDataProps } from "@raskrask-dk/raskrask-utils";


export const mapGetBookings = (bookings: DeskBookingsDTO[]): BookingDataProps[] => {
  return bookings.map((b) => {
    return {
      id: b.id,
      customerName: `${b.customer.firstName} ${b.customer.lastName}`,
      status: b.isActive ? "Active" : "Cancelled",
      partner: b.partner.alias,
      type: b.service.name,
      serviceDate: b.serviceDate.substring(0, 10),
      time: b.serviceDate.substring(11, 16),
      serviceDuration: b.service.duration,
      isMotherBooking: b.isMotherBooking,
      address: b.address,
      customerId: b.customer.id,
      profileId: b.partner.id,
      originalPrice: b.originalPrice,
      partnerShare: b.partnerShare,
      rrShare: b.rrShare,
      paymentNote: b.paymentNote,
      balance: b.balance,
      totalPrice: b.totalPrice,
    };
  });
};
